<template>
  <div class="lashmaker text-xs-center pt-4">
    <h1>Lashmakers</h1>
    <v-container>
      
      <!-- Ordina per...
      <v-layout row class="mb-4">
        <v-btn small flat color="grey" @click="sortBy('nome')">
          <v-icon left small>folder</v-icon>
          <span class="caption text-lowercase">Ordina per nome</span>
        </v-btn>
        <v-btn small flat color="grey" @click="sortBy('cognome')">
          <v-icon left small>folder</v-icon>
          <span class="caption text-lowercase">Ordina per cognome</span>
        </v-btn>
      </v-layout>
      -->


      <v-card flat class="pa-3 ma-2 lashmaker-folder" v-for="(lashmaker, index) in lashmakers" :key="lashmaker.id">
        <v-layout row wrap>
          <v-flex xs6 md2 text-xs-center>
            <div class="caption grey--text mb-3">Nome</div>
            <div>{{ lashmaker.nome }}</div>
          </v-flex>  
          <v-flex xs6 md2 text-xs-center>
            <div class="caption grey--text mb-3">Cognome</div>
            <div>{{ lashmaker.cognome }}</div>
          </v-flex>  
          <v-flex xs6 md2 text-xs-center>
            <div class="caption grey--text mb-1">foto</div>
            <v-responsive>
              <v-avatar>
                <img :src="lashmaker.imageUrl" alt="">
              </v-avatar>
            </v-responsive>
          </v-flex>  
          <v-flex xs6 md1 text-xs-center>
            <div class="caption grey--text mb-3">Effetto</div>
            <div text-xs-center>{{ lashmaker.effetti[0] }}</div>
          </v-flex> 
          <v-flex xs6 md1 text-xs-center>
            <div class="caption grey--text mb-3">Effetto</div>
            <div text-xs-center>{{ lashmaker.effetti[1] }}</div>
          </v-flex>
          <v-flex xs6 md1 text-xs-center>
            <div class="caption grey--text mb-3">Effetto</div>
            <div text-xs-center>{{ lashmaker.effetti[2] }}</div>
          </v-flex>
          <v-flex xs6 md1 text-xs-center>
            <div class="caption grey--text mb-3">Effetto</div>
            <div text-xs-center>{{ lashmaker.effetti[3] }}</div>
          </v-flex>

          <v-flex xs6 md1 text-xs-center>

            <template>
             
                <v-dialog v-model="dialog" persistent max-width="600px">
                  <template v-slot:activator="{ on }">
                    <v-btn fab color="cyan" v-on="on" @click="modificaLashmaker(lashmaker.id, index)">
                      <v-icon dark>create</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">Modifica {{nome}} {{cognome}}  </span>
                    </v-card-title>
                    <v-card-text>
                      <v-container> 

                        <v-flex text-xs-center class="mt-2">
                          <v-text-field 
                            label="Nome Lashmaker"
                            v-model="nome"
                          >
                          </v-text-field>
                        </v-flex>

                        <v-flex text-xs-center class="mt-2">
                          <v-text-field 
                            label="Cognome Lashmaker"
                            v-model="cognome"
                          >
                          </v-text-field>
                        </v-flex>

                        <v-flex text-xs-center>
                          <v-select
                                  :items="initEffetti" 
                                  v-model="effetti[0]" 
                                  clearable
                                  label="Seleziona effetto" 
                          ></v-select>
                        </v-flex>
                        <v-flex text-xs-center>
                          <v-select
                                  :items="initEffetti" 
                                  v-model="effetti[1]"
                                  clearable 
                                  label="Seleziona effetto" 
                          ></v-select>
                        </v-flex>                   
                        <v-flex text-xs-center>
                          <v-select
                                  :items="initEffetti" 
                                  v-model="effetti[2]"
                                  clearable
                                  label="Seleziona effetto" 
                          ></v-select>
                        </v-flex>                   
                        <v-flex text-xs-center>
                          <v-select
                                  :items="initEffetti" 
                                  v-model="effetti[3]"
                                  clearable 
                                  label="Seleziona effetto" 
                          ></v-select>
                        </v-flex>                                  
              
                      </v-container>
        
                    </v-card-text>
                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                      <v-btn color="blue darken-1" text @click="salvaLashmaker(id)">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
          
            </template>

          </v-flex>

          <v-flex xs6 md1 text-xs-center>
            <v-btn fab color="lash" @click="removeLash(lashmaker.id, index, lashmaker.nome, lashmaker.cognome)">
              <v-icon dark>delete</v-icon>
            </v-btn>
          </v-flex> 
        </v-layout>
      </v-card>
      
      <!-- FORM INSERIMENTO NUOVA LASHMAKER -->
      <h2 class="my-5 heading">Inserisci una nuova Lashmaker</h2>

      <v-form flat class="pa-3 ma-2 lashmaker-folder" ref="form">
        <v-layout row wrap>

          <v-flex xs6 md3 text-xs-center>
           <v-text-field label="Nome" solo flat v-model="nome"></v-text-field>
          </v-flex>  

          <v-flex xs6 md3>
           <v-text-field label="Cognome" solo flat v-model="cognome"></v-text-field>
          </v-flex>  

          <v-flex xs6 md3 text-xs-left>
            <v-btn @click="onPickFile">Upload Image</v-btn>
            <input type="file" 
                   style="display: none" 
                   ref="fileInput" 
                   accept="image/*" 
                   @change="onFilePicked"
            >
          </v-flex>

          <v-flex xs6 md3 text-xs-left>
            <img :src="imageUrl" height="50" width="50" alt="">
          </v-flex>

          <v-flex xs6 md3 text-xs-center class="px-2">
            <v-select
                    :items="initEffetti" 
                    v-model="effetti[0]" 
                    label="Seleziona effetto" 
            ></v-select>
          </v-flex>

          <v-flex xs6 md3 text-xs-center class="px-2">
             <v-select
                    :items="initEffetti" 
                    v-model="effetti[1]" 
                    label="Seleziona effetto" 
            ></v-select>
          </v-flex>

          <v-flex xs6 md3 text-xs-center class="px-2">
             <v-select
                    :items="initEffetti" 
                    v-model="effetti[2]" 
                    label="Seleziona effetto" 
            ></v-select>
          </v-flex>

          <v-flex xs6 md3 text-xs-center class="px-2">
             <v-select
                    :items="initEffetti" 
                    v-model="effetti[3]" 
                    label="Seleziona effetto" 
            ></v-select>
          </v-flex>  

        </v-layout>

        <v-btn dark class="lash" @click="submit" :loading="loading">INSERISCI</v-btn>

        <v-snackbar v-model="snackbar" :timeout="4000" color="success">
          <span>Lashmaker Aggiunta.</span>
          <v-btn flat color="white" @click="snackbar=false">Close</v-btn>
        </v-snackbar>
        <v-snackbar v-model="snackbar1" :timeout="4000" color="success">
          <span>Lashmaker Modificata.</span>
          <v-btn flat color="white" @click="snackbar1=false">Close</v-btn>
        </v-snackbar>        

      </v-form>

    </v-container>
  </div>
</template>

<script>
import fb from "@/fb"
export default {
  data() {
    return {
      lashmakers: [],
      /* inputRules: [
        v => v.length >= 2 || "Inserire almeno 2 caratteri"
      ],*/
      loading: false,
      nome: "",
      cognome: "",
      image: null,
      imageUrl: "",
      initEffetti: [ "Naturale", "Volume", "Ultramascara", "Laminazione" ],
      effetti: ["", "", "", ""],
      snackbar: false,
      snackbar1: false,
      dialog: false,
      id: null,
      initOrarioLashmaker: [
          {nomeGiorno: "Lun", inizio1: "00:00", fine1: "00:00", inizio2: "00:00", fine2: "00:00", indice: 0},
          {nomeGiorno: "Mar", inizio1: "00:00", fine1: "00:00", inizio2: "00:00", fine2: "00:00", indice: 1},
          {nomeGiorno: "Mer", inizio1: "00:00", fine1: "00:00", inizio2: "00:00", fine2: "00:00", indice: 2},
          {nomeGiorno: "Gio", inizio1: "00:00", fine1: "00:00", inizio2: "00:00", fine2: "00:00", indice: 3},
          {nomeGiorno: "Ven", inizio1: "00:00", fine1: "00:00", inizio2: "00:00", fine2: "00:00", indice: 4},
          {nomeGiorno: "Sab", inizio1: "00:00", fine1: "00:00", inizio2: "00:00", fine2: "00:00", indice: 5},
          {nomeGiorno: "Dom", inizio1: "00:00", fine1: "00:00", inizio2: "00:00", fine2: "00:00", indice: 6},
      ]               
    }
  },
  methods: {
    submit() {
      if ( this.$refs.form.validate() ) {
        // eslint-disable-next-line
        //console.log("inserita correttemente")
        this.loading = true
        const lashmaker = {
          nome : this.nome,
          cognome : this.cognome,
          imageUrl : this.imageUrl,
          effetti : this.effetti
        }
        //creo Lashmaker
        fb.db.collection("lashmaker").add(lashmaker).then(() => {
          // creo inoltre le sue relative fasce orarie inizializzate a zero

          this.initOrarioLashmaker.forEach(lashDay => {
            const orarioLashmaker = {
              nome : this.nome,
              cognome : this.cognome,
              nomeGiorno: lashDay.nomeGiorno,
              inizio1: lashDay.inizio1,
              fine1: lashDay.fine1,
              inizio2: lashDay.inizio2,
              fine2: lashDay.fine2,
              indice: lashDay.indice,
              continuato: false
            }
            fb.db.collection("orarioLashmaker").add(orarioLashmaker)
          })

          //fb.storage.ref('Lashmaker/' + this.nome + this.cognome).put(this.image)
          this.nome = ""
          this.cognome = ""
          this.imageUrl = ""
          this.image = null
          this.effetti = []
          this.loading = false
          this.snackbar = true
        })
      }    
    },
    salvaLashmaker(id) {
      //ripulisco array dai campi effetto vuoti
      this.effetti = this.effetti.filter(elem => elem != null)
      // Aggiorno collection
      fb.db.collection('lashmaker').doc(id).update({
        nome: this.nome,
        cognome: this.cognome,
        effetti: this.effetti
      })    
      // Aggiorno array interno
      this.lashmakers[this.indice].nome = this.nome
      this.lashmakers[this.indice].cognome = this.cognome
      this.lashmakers[this.indice].effetti = this.effetti
      //svuoto campi
      this.nome = null
      this.cognome = null
      this.effetti = []

      // chiudo dialog
      this.dialog = false
      this.snackbar1 = true

    },
    modificaLashmaker(id, index) {
      //console.log(this.lashmaker)
      this.id = id
      this.indice = index      
      this.nome = this.lashmakers[index].nome
      this.cognome = this.lashmakers[index].cognome
      this.effetti = this.lashmakers[index].effetti
    },
    removeLash(id, index, nome, cognome) {
      //Query che estrae dalla tabella orarioLashmaker tutte le occorrenze legate al nome da cancellare
      fb.db.collection("orarioLashmaker").where('cognome', '==', cognome)
           .get().then(res => {
             const giorni = res.docChanges()
             //utilizzo il campo id per cancellare le occorrenze estratte, rimuovendo quindi le 
             //fasce orarie legate alla lashmaker
             giorni.forEach(giorno => {
               fb.db.collection("orarioLashmaker").doc(giorno.doc.id).delete()
             })
           })
      //rimuovo lashmaker
      fb.db.collection('lashmaker').doc(id).delete()
      this.lashmakers.splice(index, 1)       
    },
    onPickFile() {
      this.$refs.fileInput.click()
    },
    onFilePicked(event) {
      const files = event.target.files
      let filename = files[0].name
      if (filename.lastIndexOf('.') <= 0) {
        return alert("Please add a valid file!")
      }
      const fileReader = new FileReader()
      fileReader.addEventListener("load", () => {
        this.imageUrl = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
      this.image = files[0]
    }
  },
  beforeCreate() {
    fb.db.collection('lashmaker').onSnapshot(res => {
      const changes = res.docChanges()
      changes.forEach(change => {
        if (change.type === "added")  {
          this.lashmakers.push({
            ...change.doc.data(),
            id: change.doc.id
          })
        }
      })
    })
  }
}
</script>

<style>
.lashmaker-folder{background: #fff; border-left: 4px solid #FF9E80!important; border-bottom: 1px solid #dddddd!important;}
</style>

